import React, { useState } from 'react';
import { PageHeader } from '../../components/layout/PageHeader';
import { KPICard } from '../../components/ui/KPICard';
import { Card } from '../../components/ui/Card';
import { DataTable } from '../../components/ui/DataTable';
import { Tabs } from '../../components/ui/Tabs';
import { Button } from '../../components/ui/Button';
import { StatusPill } from '../../components/ui/StatusPill';
import { ActivityIcon, AlertTriangleIcon, ClockIcon } from 'lucide-react';
const exceptions = [{
  id: 'INV-2026-00086',
  type: 'Invoice Exception',
  supplier: 'NutriPack Solutions',
  issue: 'Price variance on 2 line items',
  age: '3 days',
  status: 'Pending Supplier'
}, {
  id: 'INV-2026-00082',
  type: 'Invoice Exception',
  supplier: 'Bintang Raya Foods',
  issue: 'PO reference mismatch',
  age: '5 days',
  status: 'Rejected'
}, {
  id: 'PO-2026-00139',
  type: 'PO Ack Exception',
  supplier: 'NutriPack Solutions',
  issue: 'Change requested by supplier',
  age: '1 day',
  status: 'Pending Buyer'
}, {
  id: 'SHP-2026-087',
  type: 'ASN Delay',
  supplier: 'Thai Logistics Co',
  issue: 'Dispatch delayed by 2 days',
  age: '2 days',
  status: 'Open'
}];
export const TransactionMonitorPage: React.FC = () => {
  const [activeTab, setActiveTab] = useState('all');
  return <div className="max-w-7xl mx-auto space-y-6" data-id="element-782">
      <PageHeader title="Transaction Monitor" description="Track PO, ASN, and Invoice exceptions." data-id="element-783" />

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-784">
        <KPICard title="PO Ack Exceptions" value="3" icon={<AlertTriangleIcon className="w-5 h-5 text-status-warning" data-id="element-786" />} data-id="element-785" />
        <KPICard title="ASN Delays" value="2" icon={<ClockIcon className="w-5 h-5 text-status-warning" data-id="element-788" />} data-id="element-787" />
        <KPICard title="Invoice Exceptions" value="8" icon={<ActivityIcon className="w-5 h-5 text-status-error" data-id="element-790" />} data-id="element-789" />
        <KPICard title="Payment Inquiries" value="1" icon={<ActivityIcon className="w-5 h-5" data-id="element-792" />} data-id="element-791" />
      </div>

      <Card noPadding data-id="element-793">
        <div className="px-6 pt-4 border-b border-border-light flex justify-between items-center" data-id="element-794">
          <Tabs tabs={[{
          id: 'all',
          label: 'All Exceptions'
        }, {
          id: 'po',
          label: 'PO Exceptions'
        }, {
          id: 'asn',
          label: 'ASN Delays'
        }, {
          id: 'invoice',
          label: 'Invoice Exceptions'
        }]} activeTab={activeTab} onChange={setActiveTab} data-id="element-795" />
          <Button variant="secondary" size="sm" data-id="element-796">
            Send Bulk Reminders
          </Button>
        </div>
        <div className="p-6" data-id="element-797">
          <DataTable data={exceptions} columns={[{
          header: 'Reference ID',
          accessorKey: 'id',
          cell: row => <span className="font-medium text-fpg-navy" data-id="element-799">{row.id}</span>
        }, {
          header: 'Type',
          accessorKey: 'type'
        }, {
          header: 'Supplier',
          accessorKey: 'supplier'
        }, {
          header: 'Issue Description',
          accessorKey: 'issue'
        }, {
          header: 'Age',
          accessorKey: 'age'
        }, {
          header: 'Status',
          cell: row => <StatusPill status={row.status} data-id="element-800" />
        }]} data-id="element-798" />
        </div>
      </Card>
    </div>;
};